import { render } from "./Stats.vue?vue&type=template&id=2df33130&scoped=true"
import script from "./Stats.vue?vue&type=script&lang=js"
export * from "./Stats.vue?vue&type=script&lang=js"

import "./Stats.vue?vue&type=style&index=0&id=2df33130&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2df33130"

export default script